import { __awaiter } from "tslib";
import React, { useEffect, useState } from 'react';
import { useLazyDownloadReleaseNoteAsBlob } from '@/platform-services/release-notes';
import { ImageWithFallback } from '@/components/image-with-fallback';
import { logError } from '@/utils/logger';
export const ReleaseNotesImage = ({ imageUrl }) => {
    const [imageSrc, setImageSrc] = useState(null);
    const { triggerDownloadAsBlob } = useLazyDownloadReleaseNoteAsBlob();
    useEffect(() => {
        const fetchImage = () => __awaiter(void 0, void 0, void 0, function* () {
            if (imageUrl.includes('https')) {
                setImageSrc(imageUrl);
                return;
            }
            try {
                const blobUrl = yield triggerDownloadAsBlob(imageUrl);
                setImageSrc(blobUrl);
            }
            catch (error) {
                logError('Error in fetchReleaseNoteImage:', error);
            }
        });
        void fetchImage();
    }, [imageUrl, setImageSrc, triggerDownloadAsBlob]);
    if (!imageSrc) {
        return null;
    }
    return <ImageWithFallback src={imageSrc} alt={imageUrl}/>;
};
